module.exports = __webpack_public_path__ + "static/media/daftar_siswa_kelas.6d905157.png";